import { computed, inject, Injectable } from '@angular/core';
import { languages } from '@app/configurations';
import { TranslateService } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { de_DE, en_US, NzI18nService, zh_CN } from 'ng-zorro-antd/i18n';
import { getDefaultLanguage } from '../config/locale.config';
import { UserLanguage } from '../models/user.models';
import { RouterNavState } from '../store/states/router-nav/router-nav.state';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private i18n = inject(NzI18nService);
  private ts = inject(TranslateService);

  readonly language = select(RouterNavState.queryParam('lang'));

  readonly defaultLanguage = computed(() => (this.language() || this.ts.getBrowserLang()).toLowerCase());

  readonly computedLanguage = computed(
    () =>
      getDefaultLanguage(<UserLanguage>this.ts.defaultLang) ||
      (this.language() || this.ts.getBrowserLang()).toLowerCase(),
  );

  setAntLocale(lang) {
    switch (lang.toUpperCase()) {
      case languages.GERMAN:
        this.i18n.setLocale(de_DE);
        break;
      case languages.CHINESE:
        this.i18n.setLocale(zh_CN);
        break;
      case languages.ENGLISH:
        this.i18n.setLocale(en_US);
        break;
    }
  }
}
